import { z } from 'zod';

export const entityDocSchema = z.object({
  created: z.string(),
  modified: z.string().optional(),
});

export type EntityDoc = z.infer<typeof entityDocSchema>;
